// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_SUPER_ADMIN_DASHBOARD = '/super-admin/dashboard';
const ROOTS_VENDOR_DASHBOARD = '/vendor/dashboard';
const ROOTS_CLIENT_DASHBOARD = '/client/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword:'/reset-password',
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components'
};

export const PATH_DASHBOARD = {
  root: ROOTS_SUPER_ADMIN_DASHBOARD,
  superAdminRoot: ROOTS_SUPER_ADMIN_DASHBOARD,
  vendorRoot: ROOTS_VENDOR_DASHBOARD,
  clientRoot: ROOTS_CLIENT_DASHBOARD,
  general: {
    app: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/main'),
    ecommerce: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/analytics'),
    banking: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/banking'),
    booking: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/booking')
  },
  master: {
    grade: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/master/grade'),
  },
  mail: {
    root: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/mail'),
    all: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/mail/all')
  },
  chat: {
    root: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/chat'),
    new: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/chat/:conversationKey')
  },
  calendar: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/user'),
    profile: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/user/cards'),
    list: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/user/new'),
    editById: path(ROOTS_SUPER_ADMIN_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/user/account')
  },
  eCommerce: {
    root: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/e-commerce/list'),
    newProduct: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/e-commerce/product/new'),
    editById: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/e-commerce/invoice')
  },
  blog: {
    root: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/blog'),
    posts: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    newPost: path(ROOTS_SUPER_ADMIN_DASHBOARD, '/blog/new-post')
  }
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
